/**
 * The portals' one phone display format: 3053086212 renders as 305.308.6212. Shared so every place
 * that shows a phone number — the member's physician card and membership card, the provider's
 * patient directory — can't drift apart.
 *
 * Only a plain 10-digit number is reformatted. Anything else — an international number, or one
 * with an extension — is left exactly as entered: "555-1234 ext 123" also has ten digits, and
 * dotting those would show a different, wrong number.
 */
const PLAIN_NUMBER = /^[\d\s().-]+$/;

export function formatPhoneDisplay(value: string): string {
  const digits = value.replace(/\D/g, '');
  return PLAIN_NUMBER.test(value) && digits.length === 10
    ? `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`
    : value;
}
